import React from 'react';
import classnames from 'classnames';
import _ from 'lodash';

import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux'
import store from '../../Redux';
import { doPost, doLoad, doPut, select, doDelete, apiUrlOpen, socket, goBack } from '../../Redux/Actions'

import ButtonGroup from '../../Components/ButtonGroup';
import Toolbar from '@material-ui/core/Toolbar';
import BackButton from '../../Components/BackButton';
import Master from '../../Components/Master';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';

import HistoryBackButton from '../../Components/HistoryBackButton';

import KeyboardArrowUp from '@material-ui/icons/KeyboardArrowUp';
import KeyboardArrowDown from '@material-ui/icons/KeyboardArrowDown';

import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import LoaderButton from '../../Components/LoaderButton';
import CardActions from '@material-ui/core/CardActions';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import Popper from '@material-ui/core/Popper';
import MenuList from '@material-ui/core/MenuList';

import LockIcon from '@material-ui/icons/Lock';
import LockOpen from '@material-ui/icons/LockOpen';
import Button from '@material-ui/core/Button';

import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemText from '@material-ui/core/ListItemText';

import Paper from '@material-ui/core/Paper';
import Input from '@material-ui/core/Input';
import Checkbox from '@material-ui/core/Checkbox';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';

import { Cell, Column, Table, ColumnHeaderCell, EditableCell } from "@blueprintjs/table";

import AddIcon from '@material-ui/icons/Add';
import PrintIcon from '@material-ui/icons/Print';
import PdfIcon from '@material-ui/icons/PictureAsPdf';
import IconButton from '@material-ui/core/IconButton';

import { TextFieldHelper, CheckboxFieldWrapper, SelectFieldWrapperExtended } from '../../Components/Fields';
import DatePickerContainer from '../../Components/DatePickerContainer';
import convertMinutesToString from '../../Components/convertMinutesToString';
import Loader from '../../Components/Loader';

import MaskedInput from 'react-text-mask';
import { ContextMenuTarget, Menu, MenuItem as BlueprintMenuItem, Divider as BlueprintDivider, Icon } from "@blueprintjs/core";

const styles = theme => ({
    flex: {
        flex: 1
    },
    card: {
        width: "100%"
    },
    divider: {
        marginTop: 20,
        marginBottom: 20,
        marginLeft: -30,
        marginRight: -30,
    },
    kursCell: {
        width: "120px",
    },
    slotCell: {
        width: "50px",
        paddingRight: "4px",
        textAlign: "center"
    },
    cell: {
        paddingRight: "4px",
    },
    maskedInput: {
        width: "50px",
        textAlign: "center"
    },
    resultCell: {
        textAlign: "center"
    },
    colorDiv: {
        height: 15,
        boxShadow: "0 0 10px rgba(0,0,0,0.3)",
        borderRadius: "3px"
    }
})

function TextMaskCustom(props) {
    const { inputRef, ...other } = props;

    return (
        <MaskedInput
            {...other}
            ref={inputRef}
            mask={[/[0-9]/, /[0-9]/, ':', /[0-9]/, /[0-9]/]}
            placeholderChar={'0'}
            showMask
        />
    )
}

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
}

var UmlaufplanDialogForm = ({disabled, farbzuordnung, stunden_nicht_relevant, mehrfach, farbe, firstRow_Time, lastRow_Time, intern_name, kuerzel_linie, kuerzel_bus, kuerzel_nummer, km_total, min_total, handleChangeComplete, handleChange, data, classes, paket, name, eintraege, intToTime, param_ruhepause, param_lzu, param_kvrp, param_kvrp30, std_diaten}) => {
    
    var selected = []
    if(data.mo) {
        selected.push("Mo")
    }
    if(data.di) {
        selected.push("Di")
    }
    if(data.mi) {
        selected.push("Mi")
    }
    if(data.don) {
        selected.push("Do")
    }
    if(data.fr) {
        selected.push("Fr")
    }
    if(data.sa) {
        selected.push("Sa")
    }
    if(data.so) {
        selected.push("So")
    }
    if(data.feiertage) {
        selected.push("Feiertage")
    }
    if(data.ferien) {
        selected.push("Ferien")
    }

    var start = "00:00"
    var ende = "00:00"
    var zeit = "00:00"
    var wendezeit = 0
    var wendezeitAbzug = 0

    if(eintraege && eintraege.length > 0) {

        start = eintraege[0].start
        ende = eintraege[eintraege.length-1].ende

        /*wendezeit = (eintraege[eintraege.length-1].ende_raw - eintraege[0].start_raw)
        zeit = convertMinutesToString(""+(eintraege[eintraege.length-1].ende_raw - eintraege[0].start_raw))

        eintraege.forEach((item) => {
            wendezeitAbzug += item.kvrp
        }) 

        if(wendezeitAbzug > 90) {
            wendezeitAbzug = 90
        }

        wendezeit = wendezeit - wendezeitAbzug
        wendezeitAbzug = parseFloat(wendezeitAbzug)*/

    }

    return (
        <div>
            <Grid container spacing={8}>
                <TextFieldHelper disabled={disabled} n={1} value={paket} onChange={handleChange('paket')} label="Paket " />
                <TextFieldHelper disabled={disabled} n={1} value={kuerzel_linie} onChange={handleChange('kuerzel_linie')} label="Linie" />
                <TextFieldHelper disabled={disabled} n={1} value={kuerzel_bus} onChange={handleChange('kuerzel_bus')} label="Bus" />
                <TextFieldHelper disabled={disabled} n={1} value={kuerzel_nummer} onChange={handleChange('kuerzel_nummer')} label="Nummer" />
                <TextFieldHelper disabled={disabled} n={4} value={name} onChange={handleChange('name')} label="Name" />
                <TextFieldHelper disabled={disabled} n={4} value={intern_name} onChange={handleChange('intern_name')} label="Intern: Name" />
            </Grid>

            <Divider className={"divider"} />

            <Grid container spacing={8}>
                <Grid item xs={1}>
                    <DatePickerContainer disabled={disabled}
                        dateInput
                        label="Gültig von"
                        value={data.von}
                        name="von"
                        onChange={handleChange('von')}
                    />
                </Grid>
                <Grid item xs={1}>
                    <DatePickerContainer disabled={disabled}
                        dateInput
                        label="Gültig bis"
                        value={data.bis}
                        name="bis"
                        onChange={handleChange('bis')}
                    />
                </Grid>
                <SelectFieldWrapperExtended disabled={disabled}
                    n={2}
                    items={farbzuordnung.map((item) => (
                        {val: item.farbe, label: item.name, farbe: item.farbe}
                    ))}
                    name="Farbe"
                    value={farbe}
                    handleChange={handleChange('farbe')}
                />
                <Grid item xs={3}>
                    <FormControl className={classes.formControl}>
                        <InputLabel htmlFor="select-multiple-checkbox">Verfügbarkeit</InputLabel>
                        <Select disabled={disabled}
                            autoWidth={true}
                            multiple
                            value={selected}
                            onChange={handleChange}
                            renderValue={selected => selected.join(', ')}
                            MenuProps={MenuProps}
                        >
                            <MenuItem><Checkbox checked={data.mo} onChange={handleChange('mo')} /><ListItemText primary={"Montag"} /></MenuItem>
                            <MenuItem><Checkbox checked={data.di} onChange={handleChange('di')} /><ListItemText primary={"Dienstag"} /></MenuItem>
                            <MenuItem><Checkbox checked={data.mi} onChange={handleChange('mi')} /><ListItemText primary={"Mittwoch"} /></MenuItem>
                            <MenuItem><Checkbox checked={data.don} onChange={handleChange('don')} /><ListItemText primary={"Donnerstag"} /></MenuItem>
                            <MenuItem><Checkbox checked={data.fr} onChange={handleChange('fr')} /><ListItemText primary={"Freitag"} /></MenuItem>
                            <MenuItem><Checkbox checked={data.sa} onChange={handleChange('sa')} /><ListItemText primary={"Samstag"} /></MenuItem>
                            <MenuItem><Checkbox checked={data.so} onChange={handleChange('so')} /><ListItemText primary={"Sonntag"} /></MenuItem>
                            <MenuItem><Checkbox checked={data.feiertage} onChange={handleChange('feiertage')} /><ListItemText primary={"Feiertag"} /></MenuItem>
                            <MenuItem><Checkbox checked={data.ferien} onChange={handleChange('ferien')} /><ListItemText primary={"Ferien"} /></MenuItem>
                        </Select>
                    </FormControl>
                </Grid>

                <Grid item xs={4}>
                    <table className="wendezeit">
                        <tr>
                            <td>Dienstbeginn:</td>
                            <td><b>{data.start}</b></td>
                            <td>Dienstende:</td>
                            <td><b>{convertMinutesToString(data.ende_raw, true)}</b></td>
                            <td><b>= {convertMinutesToString(data.brutto_zeit)}</b></td>
                        </tr>
                        <tr>
                            <td>Wendezeit:</td>
                            <td>
                                <b>
                                    {data.wendezeit_gesamt >= 90 && data.wendezeit_gesamt}
                                    {data.wendezeit_gesamt < 90 && data.wendezeit}
                                </b>
                            </td>
                            <td>{data.wendezeit_gesamt >= 90 ? "> " : "< "} {data.param_ruhepause}</td>
                            <td></td>
                            <td><b>= {convertMinutesToString(data.netto_zeit)}</b></td>
                        </tr>
                    </table>
                </Grid>

                <Grid item xs={1}>
                    <TextFieldHelper type="number" disabled={disabled} value={std_diaten} onChange={handleChange('std_diaten')} label="Std. Diäten" />
                </Grid>

                <CheckboxFieldWrapper disabled={disabled} n={2} key={mehrfach+"mehrfach"} onChange={handleChange('mehrfach')} name="Mehrfach verwendbar" checked={mehrfach} />
                <CheckboxFieldWrapper disabled={disabled} n={3} key={stunden_nicht_relevant+"stunden_nicht_relevant"} onChange={handleChange('stunden_nicht_relevant')} name="Leitstand Stunden nicht relevant" checked={stunden_nicht_relevant} />

            </Grid>
        </div>
    )
}

class UmlaufplanTabelle extends React.Component {

    state = {
        eintraege: {}
    }

    shouldComponentUpdate(nextProps, nextState) {
        if(nextProps.umlaufplan.data.eintraege) {
            if(nextProps.umlaufplan.data.eintraege !== nextState.eintraege) {
                this.state.eintraege = nextProps.umlaufplan.data.eintraege
                return true
            }
        }
        return false
    }

    render() {
        
        var {
            umlaufplan, contextMenu, header_cellRenderer, cellRenderer, onFocusedCell, disabled
        } = this.props
        
        return (
            <Table
                bodyContextMenuRenderer={!disabled && contextMenu}
                enableRowResizing={false}
                enableColumnResizing={false}
                numRows={umlaufplan.data.eintraege ? umlaufplan.data.eintraege.length + 2 : 2}
                columnWidths={[
                    100, 220, 220, 60, 60, 60, 60, 60, 60, 60, 60, 60, 100, 100, 60
                ]}
                enableGhostCells={true}
                renderMode={"none"}
                enableFocusedCell={true}
                onFocusedCell={(data) => onFocusedCell(data)}
            >
                <Column name="Kurs/LKN" columnHeaderCellRenderer={header_cellRenderer} cellRenderer={cellRenderer} />
                <Column name="von" columnHeaderCellRenderer={header_cellRenderer} cellRenderer={cellRenderer} />
                <Column name="nach" columnHeaderCellRenderer={header_cellRenderer} cellRenderer={cellRenderer} />
                <Column name="km" columnHeaderCellRenderer={header_cellRenderer} cellRenderer={cellRenderer} />
                <Column name="von" columnHeaderCellRenderer={header_cellRenderer} cellRenderer={cellRenderer} />
                <Column name="bis" columnHeaderCellRenderer={header_cellRenderer} cellRenderer={cellRenderer} />
                <Column name="min" columnHeaderCellRenderer={header_cellRenderer} cellRenderer={cellRenderer} />

                <Column name="LZKu" columnHeaderCellRenderer={header_cellRenderer} cellRenderer={cellRenderer} />
                <Column name="LZLf" columnHeaderCellRenderer={header_cellRenderer} cellRenderer={cellRenderer} />
                <Column name="LZKum" columnHeaderCellRenderer={header_cellRenderer} cellRenderer={cellRenderer} />
                <Column name="SoMin" columnHeaderCellRenderer={header_cellRenderer} cellRenderer={cellRenderer} />
                <Column name="FU" columnHeaderCellRenderer={header_cellRenderer} cellRenderer={cellRenderer} />
                <Column name="FU<6" columnHeaderCellRenderer={header_cellRenderer} cellRenderer={cellRenderer} />
                <Column name="KvtuRp>15" columnHeaderCellRenderer={header_cellRenderer} cellRenderer={cellRenderer} />
                <Column name="KvtuRp>30" columnHeaderCellRenderer={header_cellRenderer} cellRenderer={cellRenderer} />
            </Table>
        )
    }

}

class UmlaufplanDetail extends Master {

    state = {
        newEntry: {},
        putLoading: false,
        isLoading: true,
        cols: [],
        rows: [],
        selectedOption: null,
        kurse: []
    }

    componentDidMount() {

        // FIX Dez 2021
        /*socket.on('umlaufplan_'+this.props.match.params.id, () => {
            //this.props.farbzuordnung_doLoad()
            //console.log("umlaufplan_", this.props.match.params.id)
            this.props.doLoad(this.props.match.params.id)
        });*/        

        this.props.farbzuordnung_doLoad()
        this.props.doLoad(this.props.match.params.id)
        this.props.sonderfahrt_doLoad()

        this.unsubscribe = store.subscribe(() => {

                var generic = select(store.getState(), "umlaufplan")
                if(this.state.newEntry.id === undefined) {
                    var entries = generic.data.eintraege
                    if(entries === undefined) {
                        entries = []
                    }
                    this.setState({
                        newEntry: generic.data,
                        rows: entries,
                    })
                }

                /*if(this.state.isLoading) {
                    this.setState({
                        isLoading: generic.isLoading
                    })
                }

                if(_.has(generic, "putLoading") && this.state.putLoading !== generic.putLoading) {
                    if(_.has(generic.putLoading, this.state.newEntry.id)) {
                        this.setState({
                            putLoading: generic.putLoading[this.state.newEntry.id]
                        })
                    }
                }*/

            }
        )

    }

    componentWillUnmount() {
        this.unsubscribe()
    }

    handleChangeComplete = (color) => {
        this.state.newEntry.farbe = color.hex
        this.setState({
            newEntry: this.state.newEntry
        })
    }

    handleChangeRows = (index, name) => event => {
        var val = ""
        if (event.value !== undefined) {
            val = event.value
        } else if(event.target.checked !== undefined && event.target.value === "") {
            val = event.target.checked
        } else if(event.target !== undefined) {
            val = event.target.value
        }
        if(name === "km" || event.target.type === "number") {
            val = parseFloat(event.target.value)
        }
        this.state.rows[index][name] = val
        this.setState({
            rows: this.state.rows
        })
    }

    saveAction = () => {
        this.state.newEntry.eintraege = this.props.umlaufplan.data.eintraege
        this.props.doPut(this.state.newEntry.id, this.state.newEntry)
    }

    addRow = () => {
        this.state.rows.push({
            disconnected: true
        })
        this.setState({
            rows: this.state.rows
        })
    }

    deleteRow = (index) => {
        var rows = this.state.rows
        _.pullAt(rows, [index]);
        this.setState({
            rows: rows
        })
    }

    move = (index, direction) => {
        var from = this.state.rows[index]
        var to = this.state.rows[index+direction]
        this.state.rows[index] = to
        this.state.rows[index+direction] = from
        this.setState({
            rows: this.state.rows
        })
    }

    moveUp = index => {
        this.move(index, -1)
    }

    moveDown = index => {
        this.move(index, 1)
    }

    onInputChange = index => event => {
        var nin = this.state.rows.map(item => (item.kurs))
        this.props.doSearchKurse(event, nin, this.state.newEntry.id)
    }

    changeEintrag = (value, row) => {
        var x = document.getElementsByClassName("bp3-table-cell-interactive")
        this.anchorEl = x
        this.setState({})
    }

    confirmEintrag = (value, key, row) => {
        this.changeEintrag(key, value, row)
        switch (key) {
            case "km":
                value = parseFloat((""+value).replace(",", "."))
                break
            case "start": case "ende":
                value = this.intToTime(value)
                break
        }
        if(!this.props.umlaufplan.data.eintraege) {
            this.props.umlaufplan.data.eintraege = []
        }
        if(!this.props.umlaufplan.data.eintraege[row]) {
            this.props.umlaufplan.data.eintraege[row] = {
                sort: row
            }
        }
        this.props.umlaufplan.data.eintraege[row][key] = value
        /*this.state.newEntry = this.props.umlaufplan.data
        this.saveData()*/
        this.saveAction()
    }

    onRowsReordered = (fromIndex, toIndex) => {
        if(fromIndex === toIndex) return
        var newEntries = []
        this.props.umlaufplan.data.eintraege.forEach((item, key) => {
            if(key===fromIndex) return
            if(key===toIndex) {
                var newItem = this.props.umlaufplan.data.eintraege[fromIndex]
                newItem.sort = key
                newEntries.push(newItem)
                key++
            }
            item.sort = key
            newEntries.push(item)
        })
        this.props.umlaufplan.data.eintraege = newEntries
        this.saveAction()
    }

    contextMenu = (val) => {
        var column = val.target.cols[0]
        var row = val.target.rows[0]-1
        var val = this.getValue(row)
        var other = []

        if(val.typ !== 0) {
            typ = "Leerfahrt"
            typValue = 0
            other.push(<BlueprintMenuItem onClick={() => this.changeTyp(row, "typ", typValue)} icon={"changes"} text={"Typ: " + typ} />)
        }

        if(val.typ !== 1) {
            var typ = "Kurs"
            var typValue = 1
            other.push(<BlueprintMenuItem onClick={() => this.changeTyp(row, "typ", typValue)} icon={"changes"} text={"Typ: " + typ} />)
        }


        if(val.typ !== 2) {
            other.push(<BlueprintMenuItem onClick={() => this.changeTyp(row, "typ", 2)} icon={"changes"} text={"Typ: Tätigkeit"} />)
        }
        return(
            <Menu>
                {other}
                <BlueprintMenuItem onClick={() => this.changeTyp(row, "background")} icon={val.background === 1 || val.typ === 1 ? "minus" : "plus"} text="Hintergrund" />
                <BlueprintDivider />
                <BlueprintMenuItem onClick={() => this.deleteRow(row)} icon="delete" text="Zeile löschen" />
            </Menu>
        )
    }

    contextMenuSec = (val) => {
        var column = val.target.cols[0]
        var row = val.target.rows[0]

        return(
            <Menu>
                <BlueprintMenuItem onClick={() => this.addSonderfahrt(row)} icon={"plus"} text="Hinzufügen" />
            </Menu>
        )
    }

    addSonderfahrt = (row) => {
        var value = this.props.sonderfahrt.data[row]
        var val = _.last(this.props.umlaufplan.data.eintraege)
        value.start_raw = parseFloat(val.ende_raw)
        value.start = val.ende
        value.ende_raw = parseFloat(val.ende_raw) + parseFloat(value.minuten)
        delete value.id
        this.props.umlaufplan.data.eintraege.push(value)
        this.saveAction()
    }

    deleteRow = (row) => {
        var newEntries = []
        this.props.umlaufplan.data.eintraege.forEach((item, key) => {
            if(key===row) return
            newEntries.push(item)
        })
        this.props.umlaufplan.data.eintraege = newEntries
        this.saveAction()
    }

    changeTyp = (row, key, value) => {
        var val = this.props.umlaufplan.data.eintraege[row]
        if(key === "background") {
            if(val.background === 1) {
                this.props.umlaufplan.data.eintraege[row].background = 0
            } else {
                this.props.umlaufplan.data.eintraege[row].background = 1
            }
        } else {
            this.props.umlaufplan.data.eintraege[row][key] = value
        }
        this.saveAction()
    }

    getValue = (rowIndex) => {
        if(!this.props.umlaufplan.data.eintraege) {
            return {}
        } 
        if(!this.props.umlaufplan.data.eintraege[rowIndex]) {
            return {}
        }
        var val = this.props.umlaufplan.data.eintraege[rowIndex]
        return val
    }

    onFocusedCell = (data) => {
        this.state.focus = data
        return data
    }

    getFahrzeitKumuliert = (row) => {
        var i = 0
        var kum = 0
        this.props.umlaufplan.data.eintraege.forEach((item, key) => {
            i++
            if(item.typ !== 2 && key <= row) {
                kum += parseFloat(item.ku_min) +  parseFloat(item.so_min) + parseFloat(item.lf_min)
            }
        })
        return kum
    }

    cellRenderer = (rowIndex: number, columnIndex: number) => {

            var bgColor = ""

            if(rowIndex === 0) {
                var bgColor = "#f2f2f2"
                switch (columnIndex) {
                    case 0: 
                        return <Cell style={{backgroundColor: bgColor}}>Summe</Cell>
                        break
                    case 3:
                        return <Cell style={{backgroundColor: bgColor, textAlign:"center"}}>{this.props.umlaufplan.data.km > 0 && (this.props.umlaufplan.data.km).toFixed(0)}</Cell>
                        break;
                    case 6:
                        return <Cell style={{backgroundColor: bgColor, textAlign:"center"}}>{convertMinutesToString((this.props.umlaufplan.data.min))}</Cell>
                        break;
                    case 7:
                        return <Cell style={{backgroundColor: bgColor, textAlign:"center"}}>{convertMinutesToString((this.props.umlaufplan.data.ku_min))}</Cell>
                        break;
                    case 8:
                        return <Cell style={{backgroundColor: bgColor, textAlign:"center"}}>{convertMinutesToString((this.props.umlaufplan.data.lf_min))}</Cell>
                        break;
                    case 9:
                        return <Cell style={{backgroundColor: bgColor, textAlign:"center"}}>{convertMinutesToString((this.props.umlaufplan.data.so_min))}</Cell>
                        break;
                    case 10:
                        return <Cell style={{backgroundColor: bgColor, textAlign:"center"}}>{convertMinutesToString((this.props.umlaufplan.data.p_min))}</Cell>
                        break;
                    case 11:
                        return <Cell style={{backgroundColor: bgColor, textAlign:"center"}}>{convertMinutesToString((this.props.umlaufplan.data.lzu6))}</Cell>
                        break;
                    case 12:
                        return <Cell style={{backgroundColor: bgColor, textAlign:"center"}}>{convertMinutesToString((this.props.umlaufplan.data.kvrp))}</Cell>
                        break;
                    case 13:
                        return <Cell style={{backgroundColor: bgColor, textAlign:"center"}}>{convertMinutesToString((this.props.umlaufplan.data.kvrp30))}</Cell>
                        break;
                }
                return <Cell style={{backgroundColor: bgColor}} />
            }

            if(rowIndex === this.props.umlaufplan.data.eintraege.length + 1) {
                var bgColor = "#f2f2f2"
                switch (columnIndex) {
                    case 3:
                        return <Cell style={{backgroundColor: bgColor, textAlign:"center"}}>{this.props.umlaufplan.data.km > 0 && (this.props.umlaufplan.data.km).toFixed(0)}</Cell>
                        break;
                    case 6:
                        return <Cell style={{backgroundColor: bgColor, textAlign:"center"}}>{((this.props.umlaufplan.data.min))}</Cell>
                        break;
                    case 7:
                        return <Cell style={{backgroundColor: bgColor, textAlign:"center"}}>{((this.props.umlaufplan.data.ku_min))}</Cell>
                        break;
                    case 8:
                        return <Cell style={{backgroundColor: bgColor, textAlign:"center"}}>{((this.props.umlaufplan.data.lf_min))}</Cell>
                        break;
                    case 9:
                        return <Cell style={{backgroundColor: bgColor, textAlign:"center"}}>{((this.props.umlaufplan.data.so_min))}</Cell>
                        break;
                    case 10:
                        return <Cell style={{backgroundColor: bgColor, textAlign:"center"}}>{((this.props.umlaufplan.data.p_min))}</Cell>
                        break;
                    case 11:
                        return <Cell style={{backgroundColor: bgColor, textAlign:"center"}}>{((this.props.umlaufplan.data.lzu6))}</Cell>
                        break;
                    case 12:
                        return <Cell style={{backgroundColor: bgColor, textAlign:"center"}}>{((this.props.umlaufplan.data.kvrp))}</Cell>
                        break;
                    case 13:
                        return <Cell style={{backgroundColor: bgColor, textAlign:"center"}}>{((this.props.umlaufplan.data.kvrp30))}</Cell>
                        break;
                }
            }

            rowIndex = rowIndex - 1
            var value = _.clone(this.getValue(rowIndex))

            switch (columnIndex) {
                case 4:
                    if(value.start_raw > 1440) {
                        value.start = convertMinutesToString(value.start_raw-1440)
                    }
                    break;
                case 5:
                    if(value.ende_raw > 1440) {
                        value.ende = convertMinutesToString(value.ende_raw-1440)
                    }
                    break;
            }

            if(!value) {
                value = {}
                if(columnIndex>1) {
                    return <Cell style={{backgroundColor: bgColor}} />
                }
                if(this.state.newEntry.lock) {
                    return <Cell></Cell>
                }
                return (
                    <EditableCell
                        onChange={(value) => this.changeEintrag(value, "kurs", rowIndex)}
                        onConfirm={(value) => this.confirmEintrag(value, "kurs", rowIndex)}
                        className={className}
                        value={""}
                    />
                )
            }

            if(value.typ===1 || value.background > 0) {
                bgColor = "#ddd"
            }

            var info = ""
            var className = ""
            var _key = ""
            var easy = false

            if(value.ku_min === undefined && columnIndex>5) {
                return <Cell style={{backgroundColor: bgColor}} />
            }

            switch (columnIndex) {
                case 0:
                    info = value.kurs
                    _key = "kurs"
                    break;
                case 1:
                    info = value.von
                    _key = "von"
                    break;
                case 2:
                    info = value.bis
                    _key = "bis"
                    break;
                case 3:
                    info = value.km
                    className = "text-center"
                    _key = "km"
                    break;
                case 4:
                    info = value.start
                    _key = "start"
                    className = "text-center"
                    if(value.typ === 1) {
                        easy = true
                    }
                    break;
                case 5:
                    info = value.ende
                    _key = "ende"
                    className = "text-center"
                    if(value.typ === 1) {
                        easy = true
                    }
                    break;
                case 6:
                    info = value.min
                    _key = "min"
                    className = "text-center"
                    easy = true
                    break;
                case 7:
                    info = (value.ku_min)
                    break;
                case 8:
                    info = (value.lf_min)
                    break;
                case 14:
                    info = this.getFahrzeitKumuliert(rowIndex)
                    /*if(rowIndex === 0) {
                        info = 0
                    }*/
                    break;
                case 9:
                    info = (value.so_min)
                    break;
                case 10:
                    info = (value.p_min)
                    break;
                case 11:
                    info = (value.lzu6)
                    break;
                case 12:
                    info = (value.kvrp)
                    if(!value.kvrp1) {
                        bgColor = "#f2f2f2"
                    }
                    break;
                case 13:
                    if(!value.kvrp2) {
                        bgColor = "#f2f2f2"
                    }
                    info = (value.kvrp30)
            }
            
            if(columnIndex > 6) {
                easy = true
                className = "text-center"
            }

            if(easy && columnIndex > 5) {
                return (
                    <Cell className={className} style={{backgroundColor: bgColor}}>
                        {info > 0 && info}
                    </Cell>
                )
            }

            if(easy) {
                return (
                    <Cell className={className} style={{backgroundColor: bgColor}}>
                        {info}
                    </Cell>
                )
            }
            if(this.state.newEntry.lock) {
                return <Cell className={className} style={{backgroundColor: bgColor}}>{info}</Cell>
            }
            return <EditableCell
                style={{backgroundColor: bgColor}}
                onChange={(value) => this.changeEintrag(value, _key, rowIndex)}
                onConfirm={(value) => this.confirmEintrag(value, _key, rowIndex)}
                className={className}
                value={info}
            />
        }


    header_cellRenderer = (columnIndex: number) => {
            var name = ""
            var classes = {
                "text-center": true,
                "fontSizeSmall": true
            }

            var uml = this.props.umlaufplan.data

            switch (columnIndex) {
                case 0:
                    classes["text-center"] = false
                    name = "Kurs/LKN"
                    break;
                case 1:
                    classes["text-center"] = false
                    name = "von"
                    break;
                case 2:
                    classes["text-center"] = false
                    name = "bis"
                    break;
                case 3:
                    name = "km"
                    break;
                case 4:
                    name = "start"
                    break;
                case 5:
                    name = "ende"
                    break;
                case 6:
                    name = "min"
                    break;
                case 7:
                    name = "LZKu"
                    break;
                case 8:
                    name = "LZLf"
                    break;
                case 14:
                    name = "LZKum"
                    break;
                case 9:
                    name = "SoMin"
                    break;
                case 10:
                    name = "FU"
                    break;
                case 11:
                    name = "FU<" + uml.param_lzu
                    break;
                case 12:
                    name = "KvtuRp>" + uml.param_kvrp
                    break;
                case 13:
                    name = "KvtuRp>" + uml.param_kvrp30
                    break;
            }
            return <ColumnHeaderCell
                className={classnames(classes)}
                style={{textAlign: "center"}}
                name={name}
            />
        }

    render() {

        var {
            classes, farbzuordnung, umlaufplan, sonderfahrt
        } = this.props

        var {
            newEntry
        } = this.state

        if(!umlaufplan.data.id) {
            return <Loader />
        }


        return(
            <div>

                <Toolbar>
                    <BackButton go={() => this.props.history.push("/umlaufplan")} />
                    <Typography variant="h1">
                        {newEntry.paket && " " + newEntry.paket}
                        {newEntry.kuerzel_linie && " " + newEntry.kuerzel_linie}
                        {newEntry.kuerzel_bus && "." + newEntry.kuerzel_bus}
                        {newEntry.kuerzel_nummer && "." + newEntry.kuerzel_nummer}
                        {newEntry.name && " " + newEntry.name}
                    </Typography>
                    <div className={classes.flex} />

                    <ButtonGroup
                        groupName={<div className="alignCenter"><PrintIcon  className="marginRight"/> Umlaufpläne</div>}
                        links={[
                            {icon: <PrintIcon />, label: "Drucken", onClick: () => this.props.umlaufplan_print({id: newEntry.id})},
                            {icon: <PdfIcon />, label: "Download", onClick: () => this.props.umlaufplan_print_download({id: newEntry.id})},
                        ]}
                    />

                </Toolbar>

                <Card className={classes.card}>
                    {newEntry.farbe && <div className={classes.colorDiv} style={{backgroundColor: newEntry.farbe}}></div>}
                    <CardContent>
                        <UmlaufplanDialogForm
                            disabled={this.state.newEntry.lock}
                            key={umlaufplan.isLoading + "umlaufplan"}
                            classes={classes}
                            handleChange={this.handleChange}
                            data={this.state.newEntry}
                            farbzuordnung={farbzuordnung && farbzuordnung.data}
                            {...this.state.newEntry}
                            intToTime={this.convertStringToIntHours}
                        />
                    </CardContent>
                    <CardActions className="cardAction">
                        <LoaderButton disabled={this.state.newEntry.lock} icon="save" name="Speichern" color="primary" onClick={this.saveAction} loading={this.state.putLoading} />
                        {!this.state.newEntry.lock && umlaufplan.past.length > 0 && <HistoryBackButton doReverse={this.props.history_goBack} data={umlaufplan.past} />}
                        <Button size="small" variant="raised" onClick={() => this.lock()}>{newEntry.lock ? <div className="alignCenter" ><LockOpen className="marginRight" />Entsperren</div> : <div className="alignCenter" ><LockIcon className="marginRight" />Sperren</div>}</Button>
                    </CardActions>
                </Card>

                <br />

                {this.props.umlaufplan && this.props.umlaufplan.isLoading && <Loader />}

                <UmlaufplanTabelle 
                    disabled={this.state.newEntry.lock}
                    umlaufplan={this.props.umlaufplan}
                    contextMenu={this.contextMenu}
                    header_cellRenderer={this.header_cellRenderer}
                    cellRenderer={this.cellRenderer}
                    onFocusedCell={this.onFocusedCell}
                />

                <p><small><i>Tageszeiten nach 24:00 bspw. 24:01 oder 25:59 anstatt 00:01 bzw. 01:59</i></small></p>

                <Card className="marginTop">
                    <CardContent>
                        <Grid container spacing={8}>
                            <TextFieldHelper disabled={this.state.newEntry.lock} type="number" n={1} helper="Unbezahlte Ruhepause" value={newEntry.param_ruhepause} onChange={this.handleChange('param_ruhepause')} label="Ruhepause" />
                            <TextFieldHelper disabled={this.state.newEntry.lock} type="number" n={1} helper="FU größer n" value={newEntry.param_lzu} onChange={this.handleChange('param_lzu')} label="FU > n" />
                            <TextFieldHelper disabled={this.state.newEntry.lock} type="number" n={1} helper="größer n" value={newEntry.param_kvrp} onChange={this.handleChange('param_kvrp')} label="KvtuRp:1 > n" />
                            <TextFieldHelper disabled={this.state.newEntry.lock} type="number" n={1} helper="größer n" value={newEntry.param_kvrp30} onChange={this.handleChange('param_kvrp30')} label="KvtuRp:2 > n" />
                            <TextFieldHelper disabled={this.state.newEntry.lock} type="number" n={1} helper="in Minuten" value={newEntry.param_kvrp1} onChange={this.handleChange('param_kvrp1')} label="KvtuRp:1" />
                            <TextFieldHelper disabled={this.state.newEntry.lock} type="number" n={1} helper="in Minuten" value={newEntry.param_kvrp2} onChange={this.handleChange('param_kvrp2')} label="KvtuRp:2" />
                        </Grid>
                    </CardContent>
                </Card>

                <Card className="marginTop">
                    <CardContent>
                        <Grid container spacing={8}>
                            <TextFieldHelper disabled={this.state.newEntry.lock} multiline n={12} helper="" value={newEntry.anmerkung} onChange={this.handleChange('anmerkung')} label="Anmerkung / Information" />
                        </Grid>
                    </CardContent>
                </Card>

            </div>
        )

    }

}

const mapStateToProps = state => ({
    umlaufplan: state.umlaufplan,
    farbzuordnung: state.farbzuordnung,
    sonderfahrt: state.sonderfahrt,
})

const mapDispatchToProps = (dispatch, ownProps) => ({

    history_goBack: (key) => dispatch(goBack("fahrplan",key)),

    farbzuordnung_doLoad: (filter) => dispatch(doLoad("farbzuordnung", "api/generic/farbzuordnung/list", filter)),
    sonderfahrt_doLoad: (id) => dispatch(doLoad("sonderfahrt", "api/generic/sonderfahrt/list")),
    doLoad: (id) => dispatch(doLoad("umlaufplan", "api/generic/umlaufplan/single/"+id)),
    doDelete: (id) => dispatch(doDelete("umlaufplan", "api/generic/umlaufplan/"+id, id)),
    doPut: (id, data) => dispatch(doPut("umlaufplan", "api/generic/umlaufplan/"+id, data)),

    doSearchKurse: (query, nin, umlaufplan_id) => dispatch(doLoad("kurse", "api/generic/kurse/search?s="+query+"&umlaufplan_id="+umlaufplan_id+"&kurs_nin="+nin.join(","))),

    umlaufplan_print: (filter) => dispatch(apiUrlOpen("api/pdf/umlaufplan_generell/umlaufplan.pdf", filter, true)),
    umlaufplan_print_download: (filter) => dispatch(apiUrlOpen("api/pdf/umlaufplan_generell/umlaufplan.pdf", filter, false)),

})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(UmlaufplanDetail));



// WEBPACK FOOTER //
// ./src/Routes/Umlaufplaene/Detail.js